import { hashHistory } from 'react-router';
import {PicturePageLink} from '../../../constants/info';
import { MARK_POINT_BASE64 } from '../../../constants/common';
import {isEmpty, isNotEmpty, isString} from '../../../utils/util';
import {completeMapData} from '../../../utils/chart';
import {provinceNameFormat, fieldAnomaly} from '../../../utils/formatter';
import {Event} from '../../../constants/enum';
import emitter from '../../../utils/emitter';

// 跳转锚点
export function goAnchor(id, offsetTop = -20) {
    const element = document.getElementById(id);
    if (isNotEmpty(element)) {
        window.scrollTo(0, element.offsetTop + offsetTop);
    }
}

// 锚点改变
export function changeAnchor(title) {
    return emitter.emit(Event.PIC_LOA_CHANGE, title);
}

// 用于获取url里的公司查询信息
export function checkSearch() {
    const { companyInfo } = hashHistory.getCurrentLocation().query;
    if (companyInfo && isString(companyInfo) && isNotEmpty(companyInfo)) {
        return JSON.parse(companyInfo);
    }
    return {};
    // 若无，则返回查询页
    // hashHistory.replace('/cwhx/sy');
}

// 根据路径获取页面名字
export function getPageCodeByLink(link) {
    for (let k in PicturePageLink) {
        if (PicturePageLink[k] === link) {
            return k;
        }
    }
    return '';
}

// 饼图公共颜色
export const commonColorPie = ['#F8B551', '#90BBF8', '#73CDFC', '#F99248', '#2365C4', '#ACD598', '#AAA7F9', '#097C25', '#6CBA52', '#534FCF', '#ED726C'];

// 公共接口参数
export function commonRequest(parames) {
    const { companyCode, reportYear, reportType, reportDateType } = checkSearch();
    return {
        code: companyCode,
        date: reportYear,
        reportType: reportType,
        reportDateType: reportDateType,
        ...parames
    };
}

// 异常指标合并表格
export function getCombineIndexColumns(data = []) {
    data = data || [];
    const names = []; // 存储abnormalType字段
    const sizes = []; // 存储names字段中一一对应的重复个数
    const first = [0]; // 存储names中各重复字段首次出现的index

    // 按需要合并的字段排序 ----  abnormalType
    data.sort((a, b) => (a.abnormalType > b.abnormalType ? -1 : 1));

    // 遍历生成names和sizes
    data.forEach(item => {
        const position = names.indexOf(item.abnormalType);

        if (position === -1) {
            names.push(item.abnormalType);
            sizes.push(1);
        } else {
            sizes[position] = sizes[position] + 1;
        }
    });

    // 遍历生成first
    sizes.forEach((item, index) => {
        first.push(first[index] + item);
    });

    // 动态合并表格
    function setRow(text = '--', row, index) {
        const obj = {
            children: isNaN(Number(text)) ? text : `${text}分`,
            props: {}
        };
        const position = first.indexOf(index);

        if (position !== -1) {
            obj.props.rowSpan = sizes[position];
        } else {
            obj.props.rowSpan = 0;
        }
        return obj;
    }

    return [{
        title: '风险类别',
        dataIndex: 'abnormalType',
        width: 2,
        render: setRow
    }, {
        title: '异常财务风险指标',
        dataIndex: 'abnormalValue',
        width: 5,
        render: fieldAnomaly
    }, {
        title: '异常方向',
        dataIndex: 'abnormalLevel',
        width: 1,
        render: fieldAnomaly
    }, {
        title: '评分',
        dataIndex: 'score',
        width: 3,
        render: setRow
    }];
}

// 地图
export function formatMapOption(data = []) {
    if (isEmpty(data)) {
        return {};
    }
    let val = data.map(d => {
            d.name = provinceNameFormat(d.provincename);
            d.value = d.companycount || 0;
            return d.value;
        }), 
        max = Math.max.apply(null, val), min = Math.min.apply(null, val);
    data = completeMapData(data);

    return {
        tooltip: {
            formatter: function(param) {
                return param.data && param.data.provincename ?
                    `<div>
                                    <p>${param.name}地区上市公司<span class="orange-font">${param.data.value}</span>家</p>
                            </div> ` : `${param.name}: --`;
            }
        },
        visualMap: {
            max: max === min ? max + 1 : max, // 防止最大值和最小值相等
            min,
            hoverLink: false
        },
        series: [{ data }]
    };
}

// 折线图
export function commonLineOptin(param) {
    if (isEmpty(param.lineData)) {
        return {};
    }
    let {
        lineData = [], // 折线图数据
        category = [], // 横坐标数据
        color = [], // 折线颜色
        grid, // 图标的位置
        same, // 为true时y轴的label以亿为单位和显示标题
        tip, // 为true时显示自定义提示框信息
        title // 标题
    } = param;
    let tooltip = {
            formatter: val => {
                return `<div>
                            <p>${val[0].name}</p>
                            <p>${title ? '招聘人数' : '专利数量'}：<span class="orange-font font-size-18">${val[0].value}</span></p>
                        </div>`;
            }

        },
        show = {
            show: true
        },
        gridSpecial = {
            top: 15,
            left: '6%',
            containLabel: true
        },
        lineTitle = {
            show: true,
            text: '亿\n元',
            padding: [10, 40, 0, 13],
            textStyle: {
                color: '#88A3B4',
                fontSize: 12
            },
            left: 'top'
        };
    return {
        title: same ? lineTitle : false,
        color: color,
        grid: same ? gridSpecial : grid,
        yAxis: [{
            color: '#88A3B4',
            nameTextStyle: {
                color: '#88A3B4'
            },
            axisLabel: {
                formatter: val => {
                    return same ? val / 100000000 : val;
                }
            }
        }],
        tooltip: tip ? tooltip : show,
        category: category,
        lineData: lineData
    };
}

// 饼图
export function commonPieOption(legend, center, color, data) {
    if (isEmpty(data)) {
        return {};
    }

    return {
        color: color ? color : commonColorPie,
        calculable: true,
        labelShow: true,
        legend: legend,
        tooltip: {
            formatter: val => {
                return val.name + ': ' + val.percent + '%';
            }
        },
        series: [{
            center: center,
            minAngle: 20,
            label: {
                normal: {
                    position: 'inner',
                    formatter: val => {
                        return val.percent + '%';
                    },
                    color: '#fff'
                }
            }
        }],
        data: data
    };
}

// 行业均值散点图
export function avgScatterOption(data, lineName = '行业均值') {
    if(isEmpty(data)) {
        return {};
    }
    const { points = [], current = [], averageY } = data;
    // 获取最大的X轴坐标
    let maxX = points.length + 1;

    // 高亮点
    let highlightPos = [maxX / 2, current.value];
    let scatterData = points.map((item, index) => [index, item.value]);
    let lineData = [[0, averageY], [maxX, averageY]];

    return {
        color: ['#3370C8'],
        grid: {
            top: 50,
            left: 10,
            right: 50,
            bottom: 10
        },
        tooltip: {
            show: false
        },
        xAxis: [{
            type: 'value',
            scale: false,
            axisLabel: {
                show: false
            }
        }],
        yAxis: [{
            scale: false,
            nameGap: 10
        }],
        legend: {
            right: 50
        },
        scatterData: [{
            data: scatterData,
            itemStyle: {
                borderColor: '#FFF',
                borderWidth: 2
            },
            markPoint: {
                symbol: `image://${MARK_POINT_BASE64}`,
                symbolSize: [24, 104],
                symbolOffset: [0, 36],
                label: {
                    normal: {
                        show: false
                    }
                },
                data: [{
                    name: '高亮点',
                    coord: highlightPos
                }]
            }
        }],
        lineData: [{
            name: lineName,
            data: lineData
        }]
    };
}

// 剔除概述和舞弊异常指标指数和项目原值相同的值
export function removeCommonIndex(data) {
    if (!data) {
        return '--';
    }
    let rt = /(.+)?(?:\(|（)(.+)(?=\)|）)/.exec(data);
    if (isNotEmpty(rt)) {
        return rt[1] === rt[2] ? rt[1] : data;
    }
}

// 财务舞弊表象提示前五名供应/客户
export function formatListData(data, dataIndex) {
    let objData = [], obj = {};
    data && data.forEach(item => {
        if(item.reportYear === checkSearch().reportYear) {
            obj = item;
        }
        if(item.reportYear !== checkSearch().reportYear) {
            obj['amout'] = item[dataIndex + 'Amout'];
            obj['name'] = item[dataIndex + 'Name'];
            objData.push(obj);
        }
    });
    return objData;
}


// WEBPACK FOOTER //
// ./src/components/financialPicture/common/commons.js